
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Bleiben Sie Zuhause, lautete das Motto diesen Frühling während des Lockdowns.
Also kein Ausflug an ein weiter entferntes Ziel. «Achtung, Agglo!» heisst
deshalb
`}<a parentName="p" {...{
        "href": "https://interaktiv.derbund.ch/2020/bund-sommerserie-collection/"
      }}>{`unsere Sommerserie, in der wir einen neuen Blick auf die Region werfen.`}</a></p>
    <p>{`Wir haben Sie aufgefordert, uns Ihren Geheimtipp in der Region Bern zu verraten.
Besten Dank für Ihre zahlreichen Rückmeldungen.`}</p>
    <p><strong parentName="p">{`Eine Auswahl von fünf Tipps stellen wir Ihnen hier zur Abstimmung.`}</strong>{` Der Ort,
der die meisten Stimmen auf sich vereint, werden wir besuchen und porträtieren.`}</p>
    <p><strong parentName="p">{`Folgende Orte stellen wir für Sie zur Auswahl:`}</strong></p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Chäs und Brot:`}</strong>{` Diese kleine Siedlung beim Weiler Oberbottigen verfügt über
eine der kuriosesten Ortsbezeichnungen des Landes. Und nicht nur das macht
diesen Ort speziell. Eine Legende besagt, dass hier während der Schlacht bei
Laupen das Schweizerkreuz entstanden ist.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Bundesratsbunker Geristein:`}</strong>{` Nach dem zweiten Weltkrieg suchte die
Landesregierung nach einem geeigneten Ort, eine Bunkeranlage zu errichten. Die
Wahl fiel auf einen ehemaligen Sandsteinbruch in der Gemeinde Bolligen, der zu
selben Zwecken auch schon von General Guisan ins Auge gefasst wurde.
Fertiggestellt wurde die Anlage jedoch nie, weil sich immer wieder grosse
Deckenteile lösten.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Douglasien am Ostermundigenberg:`}</strong>{` Diese Baumgattung wurde im 19.
Jahrhundert von der Amerikansichen Westküste nach Europa importiert, ist hier
aber immer noch eher selten anzutreffen. Deshalb sind die 130 Jahre alten
Douglasien am Ostermundigenberg eine Ausnahmeerscheinung, deren Erhalt zurzeit
sogar das Kantonsparlament beschäftigt.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Bramberg: Denkmal Laupenschlacht`}</strong>{` Im 14. Jahrhundert trug die Stadt Bern
einen blutigen Konflikt bei Laupen aus. Die Gegnerschaft bestand aus einer
breiten Allianz von westlichen Kräften wie der Stadt Freiburg oder dem
Fürstbistum Lausanne. Nach elftägiger Schlacht um die Burg Laupen gingen die
Berner als Sieger hervor. Daran erinnert heute ein Denkmal auf dem Bramberg
oberhalb von Neuenegg.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Wanderung Gerzensee - Chutzen - Belp`}</strong>{` Eine Wanderung, die auch für
Nicht-Spitzensportler durchaus zu bewältigen ist. Sie dauert rund 3.5 Stunden
und verspricht einen grossartigen Ausblick über die Berner Alpen.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;